import React, { Component } from "react";
import {
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Rating,
  Paper,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PaymentsIcon from "@mui/icons-material/Payments";
import VerifiedIcon from "@mui/icons-material/Verified";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StorefrontIcon from "@mui/icons-material/Storefront";

import { CartContext } from "../../comp/CartContext";
import MapDisplay from "../MapDisplay";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ py: 3, px: 2 }}>{children}</Box>}
    </div>
  );
}

class Sobre extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = { tabValue: 0 };
  }

  handleChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  render() {
    const { tabValue } = this.state;
    const data = this.context?.data || {};
    const storeName = data.name || "FazPedido";
    const address = data.address || {};
    const delivery = data.delivery || {};
    const payments = data.payments || {};
    const hours = data.hours || [];

    return (
      <Box sx={{ width: "100%", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
        {/* Header Superior Fixo */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 100,
            bgcolor: "#fff",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #eee",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Avatar
              src={`/api/store/photo/${data.logo}`}
              sx={{ width: 32, height: 32 }}
            >
              {storeName[0]}
            </Avatar>
            <Typography
              sx={{ fontWeight: 700, fontSize: "1rem", color: "#263238" }}
            >
              {storeName}
            </Typography>
          </Box>
          <IconButton
            onClick={() => window.history.back()}
            sx={{ bgcolor: "#f0f0f0" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Menu de Abas */}
        <Box sx={{ bgcolor: "#fff" }}>
          <Tabs
            value={tabValue}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Sobre" sx={{ textTransform: "none", fontWeight: 600 }} />
            <Tab label="Avaliações" sx={{ textTransform: "none", fontWeight: 600 }} />
            <Tab label="Horário" sx={{ textTransform: "none", fontWeight: 600 }} />
            <Tab label="Pagamento" sx={{ textTransform: "none", fontWeight: 600 }} />
          </Tabs>
        </Box>

        {/* CONTEÚDO: SOBRE (Localização, Descrição e Regras de Entrega) */}
        <CustomTabPanel value={tabValue} index={0}>
          {address.latitude && address.longitude && (
            <Paper elevation={0} sx={{ p: 2, borderRadius: 3, mb: 2 }}>
              <Typography variant="h6" gutterBottom fontWeight={700}>
                Nossa Localização
              </Typography>
              <Box sx={{ mb: 2 }}>
                <MapDisplay
                  lat={address.latitude}
                  lng={address.longitude}
                  titulo={address.rua || storeName}
                />
              </Box>
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <LocationOnIcon color="action" />
                <Typography variant="body2" color="text.secondary">
                  {address.rua}, {address.numero} {address.complemento ? `- ${address.complemento}` : ""}, {address.bairro} - {address.cidade}/{address.estado} (CEP: {address.cep})
                </Typography>
              </Stack>
            </Paper>
          )}

          {/* Card de Informações de Entrega dinâmicas */}
          <Paper elevation={0} sx={{ p: 2, borderRadius: 3, mb: 2 }}>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Informações de Entrega
            </Typography>
            <List disablePadding>
              {delivery.habilitarEntrega === 1 && (
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon><LocalShippingIcon color="primary" /></ListItemIcon>
                  <ListItemText
                    primary="Entrega em Domicílio"
                    secondary={`Taxa fixa/base: R$ ${Number(delivery.valorEntrega || 0).toFixed(2)} | Grátis acima de R$ ${Number(delivery.gratisAcima || 0).toFixed(2)}`}
                  />
                </ListItem>
              )}
              {delivery.entregaLocal === 1 && (
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon><LocalShippingIcon color="action" /></ListItemIcon>
                  <ListItemText primary="Entrega Local Disponível" secondary={`Raio máximo de atendimento: ${delivery.distanciaMaxima} km`} />
                </ListItem>
              )}
              {delivery.retiradaLocal === 1 && (
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon><StorefrontIcon color="action" /></ListItemIcon>
                  <ListItemText primary="Retirada no Local" secondary="Disponível para buscar os produtos pessoalmente" />
                </ListItem>
              )}
              <ListItem sx={{ px: 0 }}>
                <ListItemIcon><AccessTimeIcon color="action" /></ListItemIcon>
                <ListItemText primary="Tempo Estimado" secondary={`Entre ${delivery.tempoMin} e ${delivery.tempoMax} minutos`} />
              </ListItem>
            </List>
          </Paper>

          <Paper elevation={0} sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Descrição
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.6, whiteSpace: "pre-line" }}
            >
              {data.description || "Nenhuma descrição informada pela loja."}
            </Typography>
          </Paper>
        </CustomTabPanel>

        {/* CONTEÚDO: AVALIAÇÕES */}
        <CustomTabPanel value={tabValue} index={1}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography variant="h3" fontWeight={700} color="primary">
              {data.rating || 5}
            </Typography>
            <Rating value={data.rating || 5} precision={0.1} readOnly />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Loja verificada e avaliada
            </Typography>
          </Box>
        </CustomTabPanel>

        {/* CONTEÚDO: HORÁRIO (Dinâmico com base no array hours recebido) */}
        <CustomTabPanel value={tabValue} index={2}>
          <Paper elevation={0} sx={{ borderRadius: 3, overflow: "hidden" }}>
            <List disablePadding>
              {hours && hours.length > 0 ? (
                hours.map((h) => (
                  <ListItem key={h.day_of_week} divider sx={{ py: 1.5 }}>
                    <ListItemIcon>
                      <AccessTimeIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={h.label} />
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      color={h.isOpen ? "text.primary" : "error.main"}
                    >
                      {h.isOpen ? `${h.open_time} - ${h.close_time}` : "Fechado"}
                    </Typography>
                  </ListItem>
                ))
              ) : (
                <Box sx={{ p: 3, textAlign: "center" }}>
                  <Typography variant="body2" color="text.secondary">
                    Horários não informados.
                  </Typography>
                </Box>
              )}
            </List>
          </Paper>
        </CustomTabPanel>

        {/* CONTEÚDO: PAGAMENTO (Dinâmico conforme flags de payment) */}
        <CustomTabPanel value={tabValue} index={3}>
          <Typography variant="subtitle1" fontWeight={700} mb={2}>
            Formas de Pagamento Aceitas
          </Typography>
          <Stack
            direction="row"
            spacing={1}
            flexWrap="wrap"
            useFlexGap
            sx={{ mb: 3 }}
          >
            {payments.pix === 1 && (
              <Chip
                icon={<VerifiedIcon />}
                label="Pix"
                color="success"
                variant="outlined"
              />
            )}
            {payments.credit === 1 && (
              <Chip
                icon={<PaymentsIcon />}
                label="Cartão de Crédito"
                variant="outlined"
              />
            )}
            {payments.debit === 1 && (
              <Chip
                icon={<PaymentsIcon />}
                label="Cartão de Débito"
                variant="outlined"
              />
            )}
            {payments.money === 1 && (
              <Chip
                icon={<PaymentsIcon />}
                label="Dinheiro"
                variant="outlined"
              />
            )}
          </Stack>
        </CustomTabPanel>
      </Box>
    );
  }
}

export default Sobre;